<template>
    <div class="addition" v-loading="loading">
      <div
        class="addition-mark"
        @click="markBtn"
        v-if="commodityStatusType == true"
      ></div>
      <div class="addition-first">
        {{ indexShow == 0 ? '销售商品' : '积分商品'
        }}{{ commodityStatusType == true ? '查看' : '添加' }}
      </div>
      <div class="addition-second">
        <div class="second-title">商品名称</div>
        <div class="second-input">
          <el-input placeholder="请输入内容" v-model="commodityName" clearable>
          </el-input>
        </div>
      </div>

      <div class="addition-thirdly">
        <div class="addition-thirdly-display" v-if="indexShow == 0">
          <div class="display-list" v-for="(item, index) in 5" :key="index">
            <div class="display-list-title">
              {{
                index == 0
                  ? '商品编号'
                  : index == 1
                  ? '品牌'
                  : index == 2
                  ? '产地'
                  : index == 3
                  ? '税率'
                  : index == 4
                  ? '一级分类'
                  : ''
              }}
            </div>

            <div class="display-list-input">
              <el-input
                v-if="index == 0"
                placeholder="请输入商品编号"
                v-model="commoditySerial"
                clearable
              >
              </el-input>
              <el-input
                v-if="index == 1"
                placeholder="请输入品牌"
                v-model="commodityBrand"
                clearable
              >
              </el-input>
              <el-input
                v-if="index == 2"
                placeholder="请输入商品产地"
                v-model="commodityAddress"
                clearable
              >
              </el-input>
              <el-input
                v-if="index == 3"
                placeholder="请输入税率"
                v-model="commodityTax"
                clearable
              >
              </el-input>

              <el-select
                v-if="index == 4"
                v-model="commodityStairType"
                clearable
                placeholder="请选择"
                @change="stairChange"
              >
                <el-option
                  v-for="item in commodityStairList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
        <!--积分-->
        <div class="addition-thirdly-display" v-else>
          <div class="display-list" v-for="(item, index) in 5" :key="index">
            <div class="display-list-title">
              {{
                index == 0
                  ? '商品编号'
                  : index == 1
                  ? '品牌'
                  : index == 2
                  ? '产地'
                  : index == 3
                  ? '税率'
                  : index == 4
                  ? '供应商名称'
                  : ''
              }}
            </div>

            <div class="display-list-input">
              <el-input
                v-if="index == 0"
                placeholder="请输入商品编号"
                v-model="commoditySerial"
                clearable
              >
              </el-input>
              <el-input
                v-if="index == 1"
                placeholder="请输入品牌"
                v-model="commodityBrand"
                clearable
              >
              </el-input>
              <el-input
                v-if="index == 2"
                placeholder="请输入商品产地"
                v-model="commodityAddress"
                clearable
              >
              </el-input>
              <el-input
                v-if="index == 3"
                placeholder="请输入税率"
                v-model="commodityTax"
                clearable
              >
              </el-input>

              <el-autocomplete
                v-if="index == 4"
                class="inline-input"
                v-model="commodityOverseasType"
                :fetch-suggestions="querySearch"
                placeholder="请输入内容"
                @select="handleSelect"
                clearable
              ></el-autocomplete>
            </div>
          </div>
        </div>
        <div class="addition-thirdly-display" v-if="indexShow == 0">
          <div class="display-list" v-for="(item, index) in 5" :key="index">
            <div class="display-list-title">
              {{
                index == 0
                  ? '二级分类'
                  : index == 1
                  ? '供应商名称'
                  : index == 2
                  ? '运费模板'
                  : index == 3 && indexShow == 0
                  ? '是否特产'
                  : '返利比例'
              }}
            </div>

            <div class="display-list-input">
              <el-select
                v-if="index == 0"
                v-model="commoditySecondType"
                clearable
                placeholder="请选择"
                :disabled="indexShow == 1 ? true : false"
              >
                <el-option
                  v-for="item in commoditySecondList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>

              <el-autocomplete
                v-if="index == 1"
                class="inline-input"
                v-model="commodityOverseasType"
                :fetch-suggestions="querySearch"
                placeholder="请输入内容"
                @select="handleSelect"
                clearable
              ></el-autocomplete>

              <el-select
                v-if="index == 2"
                v-model="commodityFreightType"
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in commodityFreightList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>

              <el-select
                v-if="index == 3 && indexShow == 0"
                v-model="commoditySpecialtyType"
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in commoditySpecialtyList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>

              <div class="placeholder" v-if="index == 4 && indexShow == 0">
                <el-input
                  placeholder="请输入返利比例"
                  v-model="rebateValue"
                  clearable
                >
                </el-input>
              </div>
            </div>
          </div>
        </div>
        <!--积分-->
        <div class="addition-thirdly-display" v-else>
          <div class="display-list" v-for="(item, index) in 5" :key="index">
            <div class="display-list-title">
              {{
                index == 0
                  ? '运费模板'
                  : index == 1
                  ? '是否开启限购'
                  : index == 2
                  ? '限购单量'
                  : index == 3
                  ? '是否VIP才可兑换'
                  : ''
              }}
            </div>

            <div class="display-list-input">
              <el-select
                v-model="commodityFreightType"
                clearable
                placeholder="请选择"
                v-if="index == 0"
              >
                <el-option
                  v-for="item in commodityFreightList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>

              <el-select
                v-if="index == 1"
                v-model="isRestricted"
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in isRestrictedList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>

              <el-input
                v-if="index == 2"
                placeholder="请输入限购单量"
                v-model="restrictedNum"
                clearable
              >
              </el-input>

              <el-select
                v-if="index == 3"
                v-model="isVipRestricted"
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in isVipRestrictedList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
        </div>

        <div class="addition-thirdly-display" v-if="indexShow == 0">
          <div class="display-list" v-for="(item, index) in 5" :key="index">
            <div class="display-list-title">
              {{
                index == 0
                  ? '是否开启限购'
                  : index == 1
                  ? '限购单量'
                  : index == 2
                  ? '是否VIP才可购买'
                  : index == 3 && indexShow == 0
                  ? ''
                  : ''
              }}
            </div>

            <div class="display-list-input">
              <el-select
                v-if="index == 0"
                v-model="isRestricted"
                clearable
                placeholder="请选择"
                :disabled="indexShow == 1 ? true : false"
              >
                <el-option
                  v-for="item in isRestrictedList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>

              <el-input
                v-if="index == 1"
                placeholder="请输入限购单量"
                v-model="restrictedNum"
                clearable
              >
              </el-input>

              <el-select
                v-if="index == 2"
                v-model="isVipRestricted"
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in isVipRestrictedList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
      </div>

      <div class="addition-fourthly" v-if="indexShow == 0">
        <div class="addition-fourthly-title">定位选择</div>
        <div class="addition-fourthly-display">
          <div class="addition-fourthly-display-left">
            <div class="display-left-radio">
              <el-radio v-model="addressRadio" label="0">国内产品</el-radio>
            </div>

            <div class="display-left-city">
              <div class="city-province">
                <el-select
                  v-model="internalProvinceType"
                  :disabled="addressRadio == '0' ? false : true"
                  clearable
                  placeholder="请选择省"
                  @change="areaProvinceClick"
                >
                  <el-option
                    v-for="item in internalProvinceList"
                    :key="item.id"
                    :label="item.text"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </div>
              <div class="city-title">
                <el-select
                  v-model="internalCityType"
                  :disabled="addressRadio == '0' ? false : true"
                  clearable
                  placeholder="请选择市"
                  @change="areaCityClick"
                >
                  <el-option
                    v-for="item in internalCityList"
                    :key="item.id"
                    :label="item.text"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div class="addition-fourthly-display-right">
            <div class="display-right-radio">
              <el-radio v-model="addressRadio" label="1">海外商品</el-radio>
            </div>

            <div class="display-right-input">
              <el-input
                placeholder="请输入"
                :disabled="addressRadio == '1' ? false : true"
                v-model="addressOverseas"
                clearable
              >
              </el-input>
            </div>
          </div>
        </div>
      </div>

      <div class="addition-fifth">
        <div class="addition-fifth-left">
          <div class="addition-fifth-left-title">商品主图</div>
          <div class="addition-fifth-left-upload">
            <el-upload
              class="upload-img"
              action="https://laravel-api-manager.xmw1688.com/common/upload"
              list-type="picture-card"
              :on-success="handleSuccess"
              :limit="1"
              :show-file-list="false"
              ref="upload"
            >
              <img
                v-if="commodityMasterImg != ''"
                :src="commodityMasterImg"
                class="avatar"
              />
              <img
                v-else
                src="../../assets/common/common-uploadings.png"
                class="avatar"
              />

              <img
                class="detele"
                v-if="commodityMasterImg != ''"
                src="../../assets/common/common-detele.png"
                alt=""
                @click.stop="masterDetele"
              />
            </el-upload>
          </div>
        </div>
        <div class="addition-fifth-right">
          <div class="addition-fifth-right-title">商品详情轮播图</div>
          <div class="addition-fifth-right-display">
            <el-upload
              class="display-upload"
              action="https://laravel-api-manager.xmw1688.com/common/upload"
              list-type="picture-card"
              :on-success="handleSuccessList"
              :limit="5"
              :show-file-list="false"
              ref="upload1"
            >
              <div
                class="display-upload-list"
                v-for="(item, index) in commodityDetailsList"
                :key="index"
              >
                <img class="display-upload-list-img" :src="item" alt="" />
                <img
                  class="display-upload-detele"
                  src="../../assets/common/common-detele.png"
                  alt=""
                  @click.stop="masterDeteleList(index)"
                />
              </div>
              <img
                class="display-upload-list"
                style="cursor: pointer"
                src="../../assets/common/common-uploadings.png"
                v-if="commodityDetailsList.length < 5"
              />
            </el-upload>
          </div>
        </div>
      </div>

      <div class="addition-sixth">
        <div class="addition-sixth-title">图文详情</div>
        <div class="addition-sixth-text">
          <vue-tinymce v-model="content" :setting="setting" />
        </div>
      </div>

      <div class="addition-seventh">
        <div class="addition-seventh-title">商品规格</div>

        <div class="addition-seventh-block">
          <div
            class="addition-seventh-block-list"
            v-for="(item, index) in 2"
            :key="index"
          >
            <div class="block-list-display" v-if="index == 0">
              <div class="block-list-display-left">规格{{ index + 1 }}</div>
              <div class="block-list-display-center">
                <div
                  class="block-list-display-center-array"
                  v-for="(info, num) in firstSpecificationList"
                  :key="num"
                >
                  <div class="block-list-display-center-array-text">
                    {{ info.name }}
                  </div>

                  <img
                    class="block-list-display-center-array-img"
                    src="../../assets/common/close.png"
                    @click="addDetele(info, num, 0)"
                  />
                </div>

                <div
                  class="block-list-display-center-fixation"
                  @click="addfixationBtn(0)"
                >
                  <img
                    class="fixation-img"
                    src="../../assets/common/common-lvadd.png"
                  />
                  <div class="fixation-text">添加属性值</div>
                </div>
              </div>
              <div class="block-list-display-right" @click="roleDetele(0)">
                删除
              </div>
            </div>

            <div class="block-list-display" v-if="index == 1">
              <div class="block-list-display-left">规格{{ index + 1 }}</div>
              <div class="block-list-display-center">
                <div
                  class="block-list-display-center-array"
                  v-for="(info, num) in secondSpecificationList"
                  :key="num"
                >
                  <div class="block-list-display-center-array-text">
                    {{ info.name }}
                  </div>

                  <img
                    class="block-list-display-center-array-img"
                    src="../../assets/common/close.png"
                    @click="addDetele(info, num, 1)"
                  />
                </div>

                <div
                  class="block-list-display-center-fixation"
                  @click="addfixationBtn(1)"
                >
                  <img
                    class="fixation-img"
                    src="../../assets/common/common-lvadd.png"
                  />
                  <div class="fixation-text">添加属性值</div>
                </div>
              </div>
              <div class="block-list-display-right" @click="roleDetele(1)">
                删除
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="addition-ninth" v-if="indexShow == 0" @click="releaseCommodity">
        发布商品
      </div>
      <div
        class="addition-ninth"
        v-if="indexShow == 1"
        @click="releaseIntegralCommodity"
      >
        发布商品
      </div>

      <!-- 添加属性值 -->
      <div class="ability">
        <el-dialog
          :visible.sync="abilityDialogVisible"
          style="margin-top: 15vh"
          :show-close="false"
          @close="abilityReset"
        >
          <span slot="footer" class="dialog-footer">
            <div class="ability-div">
              <div class="ability-div-top">
                <div class="block-top-title">添加属性值</div>
                <img
                  class="block-top-close"
                  src="../../assets/common/close.png"
                  @click="abilityReset"
                />
              </div>

              <div class="ability-div-center">
                <div class="center-title">属性名称</div>
                <div class="center-input">
                  <el-input
                    placeholder="名称不可超过10个字"
                    v-model.trim="abilityTitle"
                    clearable
                  >
                  </el-input>
                </div>
              </div>

              <div class="ability-div-button">
                <!-- <div class="button-reset" @click="abilityReset">重 置</div> -->
                <div class="button-confirm" @click="abilityConfirm">确 定</div>
              </div>
            </div>
          </span>
        </el-dialog>
      </div>
    </div>
  </template>

  <script>
  import {
    getMarketDetails,
    postMarketAdd,
    getcommodityClassify,
    getsecondClass,
    getintegralDetails,
    postintegralAdd,
  } from '../../api/commodity'

  import Bus from '../../utils/bus' // bus发送跳转关闭临时组件

  // 获取供应商接口api
  import { getfreight, getsupplier } from '../../api/supplier'
  // 公共api
  import { getdistrict, postuploading } from '../../api/common'

  export default {
    data() {
      return {
        // 输入商品名称
        commodityName: '',
        // 请输入商品编号
        commoditySerial: '',
        // 请输入品牌
        commodityBrand: '',
        // 请输入商品产地
        commodityAddress: '',
        // 请输入税率
        commodityTax: '',
        // 上下架 状态选择
        commodityStatusOptions: [
          {
            value: '1',
            label: '上架',
          },
          {
            value: '2',
            label: '下架',
          },
        ],
        // 状态选中
        commodityStatusvalue: '',
        // 判断当前进入页面 编辑或者查看  false 上架  true 下架
        commodityStatusType: false,
        // 一级分类数组
        commodityStairType: '',
        commodityStairTypeId: '',
        commodityStairList: [],
        // 二级分类数组
        commoditySecondType: '',
        commoditySecondTypeId: '',
        commoditySecondList: [],
        // 供应商名称数组
        commodityOverseasType: '',
        // 供应商id
        commodityOverseasTypeId: '',
        commodityOverseasList: [],
        // 供应商选中后的那个名称
        commodityOverseasName: '',
        // 运费末班接口数组
        commodityFreightType: '',
        commodityFreightTypeId: '',
        commodityFreightList: [],
        // 是否是特产商品
        commoditySpecialtyType: '',
        commoditySpecialtyList: [
          {
            value: '0',
            label: '不是',
          },
          {
            value: '1',
            label: '是',
          },
        ],
        rebateValue: '',
        // 是否限购
        isRestricted: '',
        isRestrictedList: [
          {
            value: 0,
            label: '不是',
          },
          {
            value: 1,
            label: '是',
          },
        ],
        isVipRestricted: '',
        // 是否仅vip购买
        isVipRestrictedList: [
          {
            value: 0,
            label: '不是',
          },
          {
            value: 1,
            label: '是',
          },
        ],
        //限购数量
        restrictedNum: '',

        /* end */
        /* 定位选择  国内或者海外 */
        // 国内 省份
        internalProvinceType: '',
        // 省份名字
        internalProvinceName: '',
        internalProvinceList: [],
        // 国内 市区
        internalCityType: '',
        // 市区名字
        internalCityName: '',
        internalCityList: [],
        // 定位选择 单选框
        addressRadio: '0',
        // 定位选择  海外商品名称
        addressOverseas: '',
        /* end */
        // 商品主图
        commodityMasterImg: '',
        // 商品详情轮播图
        commodityDetailsList: [],
        // 图文详情  富文本编译器
        content: '',
        setting: {
          menubar: false,
          toolbar:
            'undo redo | fullscreen | formatselect alignleft aligncenter alignright alignjustify | link unlink | numlist bullist | image media table | fontselect fontsizeselect forecolor backcolor | bold italic underline strikethrough | indent outdent | superscript subscript | removeformat |',
          toolbar_drawer: 'sliding',
          quickbars_selection_toolbar:
            'removeformat | bold italic underline strikethrough | fontsizeselect forecolor backcolor',
          plugins: 'link image media table lists fullscreen quickbars',
          language: 'zh_CN',
          height: 350,
          statusbar: false,
          images_upload_url:
            'https://laravel-api-manager.xmw1688.com/common/upload', // 图片上传地址(自动上传)
          // 允许粘贴图片上传,及格式
          paste_data_images: true,
          images_file_types: 'jpeg,jpg,png,gif,bmp,webp',
          // 此处为图片上传处理函数 (手动上传)
          images_upload_handler: (blobInfo, success, failure, progress) => {
            let params = new FormData()
            params.append('file', blobInfo.blob())

            postuploading(params).then((res) => {
              if (res.resultStatus == true) {
                success(res.resultData) //上传成功，在成功函数里填入图片路径
              } else {
              }
            })
          },
        },
        /* 富文本编辑完毕 */
        /*------------------------------------ */
        // 第一层规格
        firstSpecificationList: [],
        // 第二层规格
        secondSpecificationList: [],

        // 用户点击添加属性值 // 开启是否开机
        abilityDialogVisible: false,
        // 用户点击添加属性值 // 添加属性值名称
        abilityTitle: '',
        /* ---------------------------- */
        // --------------------
        //  判断是商品积分还是普通商品 进入添加 普通商品 0  积分商品 1
        indexShow: 0,
        // 获取上级传递参数id
        superiorId: '',
        /* 获取接口传递参数 */
        additionObj: {},
        // 添加属性值的来源  是第一规格还是第二规格
        sourceShow: 0,
        // 供应商模糊搜索
        restaurant: [],
        // 监听用户刷新
        loading: false,
      }
    },
    created() {
      // 判断是商品积分还是普通商品 进入添加
      this.indexShow = this.$route.query.index
      // 获取上级传递参数id
      this.superiorId = this.$route.query.id

      if (this.indexShow == 0) {
        if (this.superiorId != undefined) {
          // 获取商品详情接口
          this.loading = true

          this.getMarketDetailsClick()
        } else {
          this.getcommodityClick()
          // 获取地区列表选择
          this.areaClick()
        }
      } else {
        if (this.superiorId != undefined) {
          // 获取积分商品详情接口
          this.loading = true

          this.getIntegralDetailsClick()
        } else {
          this.getcommodityClick()
          // 获取地区列表选择
          this.areaClick()
        }
      }
    },
    methods: {
      // 获取商品详情对应的数据
      getMarketDetailsClick() {
        let params = this.superiorId

        getMarketDetails(params).then((res) => {
          if (res.resultStatus == true) {
            this.additionObj = res.resultData
            this.superiorId = res.resultData.id // 商品id
            this.commodityName = res.resultData.name // 商品名称
            this.commoditySerial = res.resultData.code // 请输入商品编号
            this.commodityBrand = res.resultData.brand // 请输入品牌
            this.commodityAddress = res.resultData.chandi // 请输入商品产地
            this.commodityTax = res.resultData.shuilv // 请输入税率
            // 判断当前商品是上架还是下架
            this.commodityStatusType = res.resultData.status == 1 ? true : false
            this.commodityStatusvalue =
              res.resultData.status == 1
                ? '1'
                : res.resultData.status == 2
                ? '2'
                : '1' // 是否是上架状态
            this.commoditySpecialtyType =
              res.resultData.is_speciality == 1 ? '1' : '0'
            // 定位问题
            this.internalProvinceType = res.resultData.province_id
            this.internalCityType = res.resultData.city_id

            // 一级分类数组名称
            this.commodityStairType = res.resultData.goods_one_type_name
            this.commodityStairTypeId = res.resultData.goods_one_type_id
            // 二级分类数组名称
            this.commoditySecondType = res.resultData.goods_two_type_name
            this.commoditySecondTypeId = res.resultData.goods_two_type_id
            // 供应商名称
            this.commodityOverseasType = res.resultData.suppname
            this.commodityOverseasTypeId = res.resultData.supplier_id
            // 运费模板名称
            this.commodityFreightType = res.resultData.expressfee_name
            this.commodityFreightTypeId = res.resultData.expressfee_id
            // 获取当前商品定位选择
            this.addressRadio = res.resultData.is_overside == 0 ? '0' : '1'
            // 商品主图
            this.commodityMasterImg = res.resultData.image
            // 商品详情轮播图
            this.commodityDetailsList = res.resultData.images
            // 商品介绍图片模式
            this.introduceText = res.resultData.content
            // 商品图文详情
            this.content = res.resultData.content
            // 商品规格获取 第一层规格
            this.firstSpecificationList = res.resultData.goods_spec_one
            // 商品规格获取 第二层规格
            this.secondSpecificationList = res.resultData.goods_spec_two
            // 是否限购
            this.isRestricted = res.resultData.is_restricted
            // 是否仅vip购买
            this.isVipRestricted = res.resultData.is_vip_restricted
            //限购数量
            this.restrictedNum = res.resultData.restricted_num

            // 编辑模式 调用所有一级分类对应的接口
            this.getcommodityClick()
            // 编辑模式 调用所有二级分类对应的接口
            this.loading = false

            // 获取地区列表选择
            this.areaClick()
          }
        })
      },
      // 根据id 获取所有一级分类对应的数据
      getcommodityClick() {
        let params = {
          name: '',
          pageSize: 9999,
          pageNo: 1,
        }

        getcommodityClassify(params).then((res) => {
          if (res.resultStatus == true) {
            this.commodityStairList = []
            this.commodityStairList = res.resultData.goodsSpecOneList
          }
        })
      },
      // 用户点击选中一级分类数组
      stairChange() {
        this.commoditySecondType = ''
        let params = {
          goods_one_type_id: this.commodityStairType,
          name: '',
          pageSize: 9999,
          pageNo: 1,
        }
        getsecondClass(params).then((res) => {
          if (res.resultStatus == true) {
            this.commoditySecondList = []
            this.commoditySecondList = res.resultData.goodsSpecTwoList
          }
        })
      },
      // 获取地区省份
      areaClick() {
        let params = {}

        getdistrict(params).then((res) => {
          if (res.resultStatus == true) {
            // 获取省份
            this.internalProvinceList = res.resultData

            console.log('internalProvinceList', this.internalProvinceList)

            this.areaProvinceClick()
          }
        })
      },

      // 用户点击获取地区省份操作
      areaProvinceClick() {
        console.log('省份id', this.internalProvinceType)

        this.internalProvinceList.forEach((item, index) => {
          if (this.internalProvinceType == item.id) {
            this.internalCityList = item.data
            this.internalProvinceName = item.text
            console.log('item', item)
            this.areaCityClick()
          }
        })
        console.log('省份名称', this.internalProvinceName)
      },
      // 用户点击获取地区市区操作
      areaCityClick() {
        this.internalCityList.forEach((item, index) => {
          if (this.internalCityType == item.id) {
            this.internalCityName = item.text
          }
        })
      },
      // 用户点击显示添加属性值的框
      addfixationBtn(source) {
        this.sourceShow = source
        this.abilityTitle = ''
        if (source == 1) {
          if (this.firstSpecificationList.length != 0) {
            this.abilityDialogVisible = true
          } else {
            this.$message({
              message: '请先添加规格1',
              type: 'error',
            })
          }
        } else {
          this.abilityDialogVisible = true
        }
      },
      // 用户点击整条规格删除
      roleDetele(source) {
        if (source == 0) {
          this.firstSpecificationList = []
        } else {
          this.secondSpecificationList = []
        }
      },
      // 添加属性值弹出框 确认
      abilityConfirm() {
        if (this.abilityTitle == '') {
          this.$message({
            message: '规格属性不能为空！',
            type: 'error',
          })
          return
        }

        if (this.sourceShow == 0) {
          let Obj = {
            id: null,
            name: this.abilityTitle,
          }
          this.firstSpecificationList.push(Obj)
        } else {
          let Obj = {
            id: null,
            name: this.abilityTitle,
          }
          this.secondSpecificationList.push(Obj)
        }

        this.abilityDialogVisible = false
      },
      // 添加属性值弹出框 重置
      abilityReset() {
        this.abilityTitle = ''
        this.abilityDialogVisible = false
      },
      // 添加属性值区域 删除对应的
      addDetele(item, index, source) {
        if (source == 0) {
          this.firstSpecificationList.splice(index, 1)
        } else {
          this.secondSpecificationList.splice(index, 1)
        }
      },
      // 供应商带建议搜索
      querySearch(queryString, cb) {
        if (queryString == '') {
          cb(this.commodityOverseasList)
        } else {
          let params = {
            suppname: this.commodityOverseasType,
            phone: '',
            djrname: '',
            createStartTime: '',
            createEndTime: '',
            endStartTime: '',
            endEndTime: '',
            pageSize: 9999,
            pageNo: 1,
          }

          getsupplier(params, { condition: queryString }).then((res) => {
            if (res.resultStatus == true) {
              console.log('获取供应商列表接口', res)
              this.restaurant = res.resultData.supplierList
              //这个插件只能过滤key为value得值.所以要把获取到得后台字段给重新赋值为value
              res.resultData.supplierList.map((item) => {
                item.value = item.suppname
                return item
              })

              cb(res.resultData.supplierList)
            }
          })
        }
      },
      createFilter(queryString) {
        return (restaurant) => {
          return (
            restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
            0
          )
        }
      },
      loadAll() {
        return this.restaurant
      },
      handleSelect(item) {
        this.commodityOverseasTypeId = item.id
        console.log('选中', item)
        this.commodityOverseasName = item.suppname
        // 清空运费模板名称 和 id
        this.commodityFreightType = ''
        this.commodityFreightTypeId = ''
        this.getfreightClick()
      },
      // 带建议搜索完毕
      // 用户编辑 获取对应供应商运费模板
      getfreightClick() {
        let params = {
          freightName: '',
          supplierId: this.commodityOverseasTypeId,
        }
        getfreight(params).then((res) => {
          console.log('获取供应商模板', res)
          if (res.resultStatus == true) {
            this.commodityFreightList = res.resultData.freightList
          }
        })
      },

      // 用户选中供应商后获取供应商的id
      overseasTypeChange() {},

      // 用户添加获取供应商列表
      getsupplierClick() {
        let params = {
          suppname: '',
          phone: '',
          djrname: '',
          createStartTime: '',
          createEndTime: '',
          endStartTime: '',
          endEndTime: '',
          pageSize: 9999,
          pageNo: 1,
        }

        getsupplier(params).then((res) => {
          if (res.resultStatus == true) {
            this.commodityOverseasList = res.resultData.supplierList
          }
        })
      },

      AAA(e) {
        console.log('监听', e)
      },

      // 主图 点击上传
      // 上传成功
      handleSuccess(file, fileList) {
        this.$refs.upload.clearFiles()
        this.commodityMasterImg = file.resultData
        this.commodityDetailsList.push(file.resultData)
      },
      masterDetele() {
        this.commodityMasterImg = ''
      },

      // 轮播图图片数组上传
      // 上传成功
      handleSuccessList(file, fileList) {
        this.$refs.upload1.clearFiles()

        if (this.commodityMasterImg == '') {
          this.commodityMasterImg = file.resultData
        }

        this.commodityDetailsList.push(file.resultData)
      },
      masterDeteleList(index) {
        this.commodityDetailsList.splice(index, 1)
      },

      /* end */
      // 普通商品 用户点击发布商品
      releaseCommodity() {
        console.log('普通商品', this.rebateValue)
        console.log('一级id', typeof this.commodityStairType)
        console.log('二级id', this.commoditySecondType)
        console.log('供应商id', typeof this.commodityOverseasTypeId)
        console.log('运费模板id', this.commodityFreightType)

        console.log('查看富文本', this.content)

        if (this.firstSpecificationList.length == 0) {
          this.$message({
            message: '商品规格属性不得为空！',
            type: 'error',
            duration: 2000,
          })
          return
        }

        // 判断当前是否是海外  如果不是海外则继续判断省份是否有空
        console.log('1', this.internalProvinceName)
        console.log('1', this.internalCityName)

        if (this.addressRadio == 0) {
          if (this.internalProvinceName == '' && this.internalCityName == '') {
            this.$message({
              message: '抱歉 国内产品定位选择 省市必须填写！',
              type: 'error',
              duration: 2000,
            })
            return
          }
        }

        let params = {}

        if (this.superiorId != undefined) {
          let additionObj = this.additionObj

          params = {
            id: this.superiorId, // 商品id
            name: this.commodityName, //  商品名称
            code: this.commoditySerial, // 商品编号
            brand: this.commodityBrand, // 品牌名称
            chandi: this.commodityAddress, // 产地
            shuilv: this.commodityTax, // 税率(%)
            goods_one_type_id:
              typeof this.commodityStairType == 'number'
                ? this.commodityStairType
                : this.commodityStairTypeId, // 一级分类id
            goods_two_type_id:
              typeof this.commoditySecondType == 'number' &&
              this.commoditySecondType != ''
                ? this.commoditySecondType
                : this.commoditySecondType == ''
                ? ''
                : this.commoditySecondTypeId, // 二级分类id
            supplier_id: this.commodityOverseasTypeId, // 供应商id
            expressfee_id:
              typeof this.commodityFreightType == 'number'
                ? this.commodityFreightType
                : this.commodityFreightTypeId, // 运费模板id
            status: this.commodityStatusvalue == 1 ? 1 : 0, // 商品是否上架
            is_speciality: Number(this.commoditySpecialtyType), // 是否特产 1是
            is_handpick: 0, // 是否精选 1是
            is_overside: Number(this.addressRadio), //  是否是海外 1是 若海外则只读省 且变为输入框
            province_id: this.internalProvinceType, // 省id
            province: this.internalProvinceName, // 省
            city_id: this.internalCityType, // 市id
            city: this.internalCityName, // 市
            image: this.commodityMasterImg, // 商品主图
            images: this.commodityDetailsList, // 商品轮播图 一维数组
            introduce: '', // 商品简介
            rebate_rate: this.rebateValue, // 返利比例
            content: this.content, // 商品介绍 富文本
            goods_spec_one: this.firstSpecificationList, // 规格一列表
            goods_spec_two: this.secondSpecificationList, // 规格二列表
            is_restricted: this.isRestricted, // 是否限购
            is_vip_restricted: this.isVipRestricted, //是否仅vip购买
            restricted_num: this.restrictedNum, //限购数量
          }
        } else {
          params = {
            id: '', // 商品id
            name: this.commodityName, //  商品名称
            code: this.commoditySerial, // 商品编号
            brand: this.commodityBrand, // 品牌名称
            chandi: this.commodityAddress, // 产地
            shuilv: this.commodityTax, // 税率(%)
            goods_one_type_id: this.commodityStairType, // 一级分类id
            goods_two_type_id: this.commoditySecondType, // 二级分类id
            supplier_id: this.commodityOverseasTypeId, // 供应商id
            expressfee_id: this.commodityFreightType, // 运费模板id
            status: this.commodityStatusvalue == 1 ? 1 : 0, // 商品是否上架
            is_speciality: Number(this.commoditySpecialtyType), // 是否特产 1是
            is_handpick: 0, // 是否精选 1是
            is_overside: Number(this.addressRadio), //  是否是海外 1是 若海外则只读省 且变为输入框
            province_id: this.internalProvinceType, // 省id
            province: this.internalProvinceName, // 省
            city_id: this.internalCityType, // 市id
            city: this.internalCityName, // 市
            image: this.commodityMasterImg, // this.commodityMasterImg, // 商品主图
            images: this.commodityDetailsList, // 商品轮播图 一维数组
            introduce: '', // 商品简介
            rebate_rate: this.rebateValue, // 返利比例
            content: this.content, // 商品介绍 富文本
            goods_spec_one: this.firstSpecificationList, // 规格一列表
            goods_spec_two: this.secondSpecificationList, // 规格二列表
            is_restricted: this.isRestricted, // 是否限购
            is_vip_restricted: this.isVipRestricted, //是否仅vip购买
            restricted_num: this.restrictedNum, //限购数量
          }
        }

        postMarketAdd(params).then((res) => {
          if (res.resultStatus == true) {
            this.$message({
              message: this.superiorId ? '修改成功！' : '新增成功！',
              type: 'success',
              duration: 2000,
            })

            Bus.$emit('detele', 'commodityAdd')
          } else {
            //   this.$message({
            //     message:
            //       params.expressfee_id == ''
            //         ? '运费模板未选中'
            //         : params.goods_one_type_id == ''
            //         ? '商品一级分类未选中'
            //         : params.goods_two_type_id == ''
            //         ? '商品二级分类未选中'
            //         : params.supplier_id == ''
            //         ? '商品供应商名称未选中'
            //         : res.errorMessage,
            //     type: 'error',
            //     duration: 2000,
            //   })
          }
        })
      },

      //***************************************************************** */
      // 获取积分商品详情对应的数据
      getIntegralDetailsClick() {
        let params = this.superiorId

        getintegralDetails(params).then((res) => {
          if (res.resultStatus == true) {
            this.additionObj = res.resultData
            this.superiorId = res.resultData.id // 商品id
            this.commodityName = res.resultData.name // 商品名称
            this.commoditySerial = res.resultData.code // 请输入商品编号
            this.commodityBrand = res.resultData.brand // 请输入品牌
            this.commodityAddress = res.resultData.chandi // 请输入商品产地
            this.commodityTax = res.resultData.shuilv // 请输入税率
            // 判断当前商品是上架还是下架
            this.commodityStatusType = res.resultData.status == 1 ? true : false
            this.commodityStatusvalue =
              res.resultData.status == 1
                ? '1'
                : res.resultData.status == 2
                ? '2'
                : '1' // 是否是上架状态
            this.commoditySpecialtyType =
              res.resultData.is_speciality == 1 ? '1' : '0'
            // 一级分类数组名称
            this.commodityStairType = res.resultData.goods_one_type_name
            this.commodityStairTypeId = res.resultData.goods_one_type_id
            // 二级分类数组名称
            this.commoditySecondType = res.resultData.goods_two_type_name
            this.commoditySecondTypeId = res.resultData.goods_two_type_id
            // 供应商名称
            this.commodityOverseasType = res.resultData.suppname
            this.commodityOverseasTypeId = res.resultData.supplier_id
            // 运费模板名称
            this.commodityFreightType = res.resultData.expressfee_name
            this.commodityFreightTypeId = res.resultData.expressfee_id
            // 获取当前商品定位选择
            this.addressRadio = res.resultData.is_overside == 0 ? '0' : '1'
            // 商品主图
            this.commodityMasterImg = res.resultData.image
            // 商品详情轮播图
            this.commodityDetailsList = res.resultData.images
            // 商品介绍图片模式
            this.introduceText = res.resultData.content
            // 商品图文详情
            this.content = res.resultData.content
            // 商品规格获取 第一层规格
            this.firstSpecificationList = res.resultData.goods_spec_one
            // 商品规格获取 第二层规格
            this.secondSpecificationList = res.resultData.goods_spec_two
            console.log('---------------------------------------------------------------------')
            // 是否限购
            this.isRestricted = res.resultData.is_restricted
            // 是否仅vip购买
            this.isVipRestricted = res.resultData.is_vip_restricted
            //限购数量
            this.restrictedNum = res.resultData.restricted_num
            // 编辑模式 调用所有一级分类对应的接口
            this.getcommodityClick()
            // 编辑模式 调用所有二级分类对应的接口
            this.loading = false
          }
        })
      },

      // 积分商品 用户点击发布商品
      releaseIntegralCommodity() {
        if (this.firstSpecificationList.length == 0) {
          this.$message({
            message: '商品规格属性不得为空！',
            type: 'error',
            duration: 2000,
          })
          return
        }

        let params = {}

        if (this.superiorId != undefined) {
          let additionObj = this.additionObj

          params = {
            id: this.superiorId, // 商品id
            name: this.commodityName, //  商品名称
            code: this.commoditySerial, // 商品编号
            brand: this.commodityBrand, // 品牌名称
            chandi: this.commodityAddress, // 产地
            shuilv: this.commodityTax, // 税率(%)
            goods_one_type_id:
              typeof this.commodityStairType == 'number'
                ? this.commodityStairType
                : this.commodityStairTypeId, // 一级分类id
            goods_two_type_id:
              typeof this.commoditySecondType == 'number' &&
              this.commoditySecondType != ''
                ? this.commoditySecondType
                : this.commoditySecondType == ''
                ? ''
                : this.commoditySecondTypeId, // 二级分类id
            supplier_id: this.commodityOverseasTypeId, // 供应商id
            expressfee_id:
              typeof this.commodityFreightType == 'number'
                ? this.commodityFreightType
                : this.commodityFreightTypeId, // 运费模板id
            status: this.commodityStatusvalue == 1 ? 1 : 0, // 商品是否上架
            is_speciality: Number(this.commoditySpecialtyType), // 是否特产 1是
            is_handpick: 0, // 是否精选 1是
            is_overside: Number(this.addressRadio), //  是否是海外 1是 若海外则只读省 且变为输入框
            province_id: this.internalProvinceType, // 省id
            province: this.internalProvinceName, // 省
            city_id: this.internalCityType, // 市id
            city: this.internalCityName, // 市
            image: this.commodityMasterImg, // 商品主图
            images: this.commodityDetailsList, // 商品轮播图 一维数组
            introduce: '', // 商品简介
            content: this.content, // 商品介绍 富文本
            goods_spec_one: this.firstSpecificationList, // 规格一列表
            goods_spec_two: this.secondSpecificationList, // 规格二列表
            is_restricted: this.isRestricted, // 是否限购
            is_vip_restricted: this.isVipRestricted, //是否仅vip购买
            restricted_num: this.restrictedNum, //限购数量
          }
        } else {
          params = {
            id: '', // 商品id
            name: this.commodityName, //  商品名称
            code: this.commoditySerial, // 商品编号
            brand: this.commodityBrand, // 品牌名称
            chandi: this.commodityAddress, // 产地
            shuilv: this.commodityTax, // 税率(%)
            goods_one_type_id: this.commodityStairType, // 一级分类id
            goods_two_type_id: this.commoditySecondType, // 二级分类id
            supplier_id: this.commodityOverseasTypeId, // 供应商id
            expressfee_id: this.commodityFreightType, // 运费模板id
            status: this.commodityStatusvalue == 1 ? 1 : 0, // 商品是否上架
            is_speciality: Number(this.commoditySpecialtyType), // 是否特产 1是
            is_handpick: 0, // 是否精选 1是
            is_overside: Number(this.addressRadio), //  是否是海外 1是 若海外则只读省 且变为输入框
            province_id: this.internalProvinceType, // 省id
            province: this.internalProvinceName, // 省
            city_id: this.internalCityType, // 市id
            city: this.internalCityName, // 市
            image: this.commodityMasterImg, // this.commodityMasterImg, // 商品主图
            images: this.commodityDetailsList, // 商品轮播图 一维数组
            introduce: '', // 商品简介
            content: this.content, // 商品介绍 富文本
            goods_spec_one: this.firstSpecificationList, // 规格一列表
            goods_spec_two: this.secondSpecificationList, // 规格二列表
            is_restricted: this.isRestricted, // 是否限购
            is_vip_restricted: this.isVipRestricted, //是否仅vip购买
            restricted_num: this.restrictedNum, //限购数量
          }
        }

        postintegralAdd(params).then((res) => {
          if (res.resultStatus == true) {
            this.$message({
              message: this.superiorId ? '修改成功！' : '新增成功！',
              type: 'success',
              duration: 2000,
            })

            Bus.$emit('detele', 'commodityAdd')
          } else {
            //   this.$message({
            //     message:
            //       params.expressfee_id == ''
            //         ? '运费模板未选中'
            //         : params.goods_one_type_id == ''
            //         ? '商品一级分类未选中'
            //         : params.goods_two_type_id == ''
            //         ? '商品二级分类未选中'
            //         : params.supplier_id == ''
            //         ? '商品供应商名称未选中'
            //         : res.errorMessage,
            //     type: 'error',
            //     duration: 2000,
            //   })
          }
        })
      },

      // 点击蒙层提示
      markBtn() {
        this.$message({
          message: '需商品下架才可进行编辑！',
          type: 'error',
          duration: 2000,
        })
      },
    },
  }
  </script>

  <style lang="less" scoped>
  /deep/ .el-input__inner:focus {
    border-color: rgba(217, 217, 217, 1);
  }

  /deep/ .el-textarea__inner:focus {
    border-color: rgba(217, 217, 217, 1);
  }

  /deep/ .el-select .el-input.is-focus .el-input__inner {
    border-color: rgba(255, 255, 255, 0);
  }

  .addition {
    min-height: 978px;
    background: #ffffff;
    box-shadow: 0px 0px 10px 0px #edeff7;
    border-radius: 10px;
    padding: 26px 24px;
    box-sizing: border-box;
    position: relative;

    .addition-mark {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(255, 255, 255, 0.1);
      z-index: 9999;
    }

    .addition-first {
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: #222222;
    }

    .addition-second {
      margin-top: 24px;

      .second-title {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
      }

      .second-input {
        width: 606px;
        height: 32px;
        background: #ffffff;
        border-radius: 5px;
        margin-top: 4px;

        /deep/ .el-input {
          height: 32px;
        }

        /deep/ .el-input__inner {
          padding: 0 10px;
          box-sizing: border-box;
          height: 32px;
          background-color: rgba(255, 255, 255, 0);
        }
      }
    }

    .addition-thirdly {
      .addition-thirdly-display {
        display: flex;
        margin-top: 22px;

        .display-list {
          margin-right: 3.1vw;

          .display-list-title {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
          }

          .display-list-input {
            margin-top: 4px;

            /deep/ .el-input {
              width: 270px;
              height: 32px;
            }

            /deep/ .el-input__inner {
              padding: 0 10px;
              box-sizing: border-box;
              height: 32px;
              background-color: rgba(255, 255, 255, 0);
            }

            /deep/ .el-select .el-input.is-focus .el-input__inner {
              border-color: rgba(217, 217, 217, 1);
            }

            .placeholder {
              width: 270px;
            }
          }
        }

        .display-list:last-child {
          margin-right: 0;
        }
      }
    }

    .addition-fourthly {
      margin-top: 23px;
      padding-top: 24px;
      height: 131px;
      box-sizing: border-box;
      border-top: 1px solid #f4f5f9;
      border-bottom: 1px solid #f4f5f9;

      .addition-fourthly-title {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
      }

      .addition-fourthly-display {
        display: flex;

        .addition-fourthly-display-left {
          .display-left-radio {
            margin-top: 10px;
          }

          .display-left-city {
            display: flex;
            margin-top: 9px;

            .city-province,
            .city-title {
              width: 128px;

              /deep/ .el-input {
                width: 128px;
                height: 32px;
              }

              /deep/ .el-input__inner {
                padding: 0 10px;
                box-sizing: border-box;
                height: 32px;
                background-color: rgba(255, 255, 255, 0);
              }

              /deep/ .el-select .el-input.is-focus .el-input__inner {
                border-color: rgba(217, 217, 217, 1);
              }
            }

            .city-title {
              margin-left: 14px;
            }
          }
        }

        .addition-fourthly-display-right {
          margin-left: 66px;

          .display-right-radio {
            margin-top: 10px;
          }

          .display-right-input {
            margin-top: 9px;

            /deep/ .el-input {
              width: 270px;
              height: 32px;
            }

            /deep/ .el-input__inner {
              padding: 0 10px;
              box-sizing: border-box;
              height: 32px;
              background-color: rgba(255, 255, 255, 0);
            }
          }
        }
      }
    }

    .addition-fifth {
      margin-top: 24px;
      display: flex;

      .addition-fifth-left {
        .addition-fifth-left-title {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
        }

        .addition-fifth-left-upload {
          width: 100px;
          height: 100px;
          margin-top: 8px;
          cursor: pointer;
          position: relative;

          .upload-img {
            width: 100px;
            height: 100px;
            position: relative;

            /deep/ .el-upload--picture-card {
              width: 100px;
              height: 100px;
              display: flex;
              align-items: center;
              justify-content: center;
              border: 1px solid rgba(255, 255, 255, 0);
            }

            /deep/ .el-upload--picture-card:hover {
              border-color: rgba(255, 255, 255, 0);
            }

            /deep/ .el-upload-list--picture-card .el-upload-list__item {
              width: 100px;
              height: 100px;
              margin: 0;
            }

            .avatar {
              width: 100px;
              height: 100px;
            }

            .detele {
              position: absolute;
              top: -10px;
              right: -10px;
              width: 20px;
              height: 20px;
            }
          }
        }
      }

      .addition-fifth-right {
        margin-left: 236px;

        .addition-fifth-right-title {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
        }

        .addition-fifth-right-display {
          display: flex;
          margin-top: 8px;

          .display-upload {
            display: flex;

            /deep/ .el-upload--picture-card {
              width: 100%;
              height: 100px;
              display: flex;
              align-items: center;
              border: 1px solid rgba(255, 255, 255, 0);
            }

            /deep/ .el-upload--picture-card:hover {
              border-color: rgba(255, 255, 255, 0);
            }

            /deep/ .el-upload-list--picture-card .el-upload-list__item {
              width: 100px;
              height: 100px;
              margin: 0;
            }

            .display-upload-list {
              width: 100px;
              height: 100px;
              margin-right: 24px;
              position: relative;

              .display-upload-list-img {
                width: 100px;
                height: 100px;
              }
            }

            .display-upload-list:last-child {
              margin-right: 0;
            }

            .display-upload-detele {
              position: absolute;
              top: -10px;
              right: -10px;
              width: 20px;
              height: 20px;
            }
          }
        }
      }
    }

    .addition-sixth {
      margin-top: 24px;

      .addition-sixth-title {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
      }

      .addition-sixth-text {
        width: 601px;
        height: 400px;
        margin-top: 8px;
      }
    }

    .addition-seventh {
      border-top: 1px solid #f4f5f9;
      border-bottom: 1px solid #f4f5f9;
      padding-top: 17px;
      padding-bottom: 17px;
      box-sizing: border-box;
      margin-top: 23px;

      .addition-seventh-title {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
      }

      .addition-seventh-block {
        margin: 8px 0;

        .addition-seventh-block-list {
          box-sizing: border-box;
          width: 971px;
          border: 1px solid #e8e8e8;
          position: relative;
          margin-bottom: 10px;

          .block-list-display {
            display: flex;
            height: 100%;

            .block-list-display-left {
              width: 104px;
              min-height: 58px;
              border-radius: 3px;
              font-size: 14px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #333333;
              display: flex;
              align-items: center;
              justify-content: center;
              background: #fafafa;
            }

            .block-list-display-center {
              display: flex;
              flex-wrap: wrap;
              padding: 0 24px;
              width: 800px;
              box-sizing: border-box;

              .block-list-display-center-array {
                padding: 0 12px;
                display: flex;
                align-items: center;
                height: 30px;
                border-radius: 3px;
                border: 1px solid #d9d9d9;
                margin-right: 12px;
                margin-top: 12px;

                .block-list-display-center-array-text {
                  font-size: 14px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #333333;
                }

                .block-list-display-center-array-img {
                  width: 10px;
                  height: 10px;
                  margin-left: 11px;
                  cursor: pointer;
                }
              }

              .block-list-display-center-fixation {
                padding: 0 12px;
                display: flex;
                align-items: center;
                height: 30px;
                border-radius: 3px;
                border: 1px solid #36c100;
                cursor: pointer;
                margin-top: 12px;

                .fixation-img {
                  width: 10px;
                  height: 10px;
                  margin-right: 8px;
                }

                .fixation-text {
                  font-size: 14px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #36c100;
                }
              }
            }

            .block-list-display-right {
              width: 66px;
              min-height: 58px;
              display: flex;
              align-items: center;
              justify-content: center;
              position: absolute;
              right: 0;
              top: 0;
              cursor: pointer;
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #ed6d1f;
              border-left: 1px solid #e8e8e8;
            }
          }
        }
      }
    }

    .addition-ninth {
      width: 88px;
      height: 36px;
      background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
      border-radius: 10px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      text-align: center;
      line-height: 36px;
      margin-top: 32px;
      cursor: pointer;
    }

    // 添加属性值
    .ability {
      /deep/ .el-dialog {
        width: 444px;
        height: 210px;
        background: #ffffff;
        box-shadow: 0px 12px 48px 16px rgba(0, 0, 0, 0.03),
          0px 9px 28px 0px rgba(0, 0, 0, 0.05),
          0px 6px 16px -8px rgba(0, 0, 0, 0.08);
        border-radius: 10px;
      }

      /deep/ .el-dialog__footer {
        padding: 0;
        text-align: left;
      }

      .ability-div {
        .ability-div-top {
          display: flex;
          height: 56px;
          align-items: center;
          justify-content: space-between;
          padding: 0 24px;
          box-sizing: border-box;
          border-bottom: 1px solid #e9edf4;

          .block-top-title {
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 600;
            color: #222222;
          }

          .block-top-close {
            width: 10px;
            height: 10px;
            cursor: pointer;
          }
        }

        .ability-div-center {
          padding: 0 24px;
          box-sizing: border-box;
          margin-top: 20px;

          .center-title {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
          }

          .center-input {
            width: 100%;
            margin-top: 4px;

            /deep/ .el-input {
              height: 32px;
            }

            /deep/ .el-input__inner {
              padding: 0 10px;
              box-sizing: border-box;
              height: 32px;
              background-color: rgba(255, 255, 255, 0);
            }
          }
        }

        .ability-div-button {
          width: 100%;
          height: 52px;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          padding: 0 16px;
          box-sizing: border-box;
          border-top: 1px solid #d9d9d9;
          margin-top: 25px;

          .button-reset,
          .button-confirm {
            width: 65px;
            height: 32px;
            background: #ffffff;
            border-radius: 10px;
            border: 1px solid #e9edf4;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #555555;
            text-align: center;
            line-height: 32px;
            cursor: pointer;
          }

          .button-confirm {
            background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
            color: #ffffff;
            margin-left: 8px;
          }
        }
      }
    }
  }
  </style>
